import styled from "styled-components";



export const StorySection = styled.section`
padding: 4.5% 0 9.4%;
`

export const StoryTitle = styled.div`
text-align: center;
text-transform: uppercase;
font-weight:700;
letter-spacing: 0.25rem;
margin-bottom:1rem;
`

export const StoryContent = styled.div`
display: flex;
justify-content: space-between;
align-items: flex-end;
margin-top: 4.3%;
@media (max-width:61.98rem) {
   display: block;
}
`

export const StoryContentBlock = styled.div`
flex: 0 0 50%;
`
export const StoryContentShellLeft = styled.div`
width:80%;
`

export const StoryContentShellRight = styled.div`
display: flex;
justify-content: space-between;
@media (max-width:47.94rem) {
   display: block;
}
`
export const StoryContentTitle = styled.div`
font-size: 1.5rem;
font-weight:700;
line-height: 1.8rem;
margin-bottom:6%;
span{
   color:rgba(22, 172, 232, 1);
}

`

export const StoryContentText = styled.div`
font-size: 0.9rem;
line-height: 1.5rem;
@media (max-width:47.94rem) {
margin-bottom: 1rem;
}

`

